export default "__VITE_ASSET__FC05I2jy__"